import { styled } from "@acko-tech/building-blocks.ui.common";

export const Wrapper = styled.div`
  border-radius: 12px;
  margin: 0 auto 12px;
`;

export const TagsWrapper = styled.div`
  display: flex;
`;

export const Tag = styled.div`
  border-radius: 8px;
  background: #f5f0ff;
  padding: 4px 8px;
  color: #451999;
  font-size: 12px;
  margin: 0 8px 12px 0;
  height: 26px;
  box-sizing: border-box;
  line-height: 18px;
  font-weight: 400;
`;

export const GarageName = styled.div`
  color: #040222;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const RatingsWrapper = styled.div`
  margin: 4px 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const StarIcon = styled.img``;

export const Rating = styled.div`
  color: #5b5675;
  font-size: 12px;
  line-height: 18px;
  margin: 0 0 0 4px;
  font-weight: 400;
  line-height: 18px;
`;

export const Address = styled(Rating)`
  margin: 4px 0 0;
`;

export const DottedLine = styled.div`
  width: 100%;
  height: 2px;
  background: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="320" height="2" viewBox="0 0 320 2" fill="none"%3E%3Cpath d="M0 1H320" stroke="%23E0E0E8" stroke-dasharray="4 4"/%3E%3C/svg%3E')
    repeat;
  margin: 20px 0px 20px 0px;
`;
